module.exports = __webpack_public_path__ + "fonts/a817be30/proxima_nova_bold-punc.woff";